import { Button, useMediaQuery, useTheme } from "@mui/material";
import { ReactElement } from "react";

type Props = {
  href: string;
  children?: ReactElement | string;
  width?: number;
  right?: number | string;
  color?:
    | "primary"
    | "inherit"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
};

export const MoreButton = ({ href, children, width, right, color }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Button
      variant="contained"
      color={color ? color : "primary"}
      sx={{
        position: "relative",
        width: width ?? (isMobile ? 180 : 240),
      }}
      href={href}
    >
      {children ? children : "more"}
      <img
        src="/images/btn-arr.png"
        alt=""
        style={{
          position: "absolute",
          top: "50%",
          right: right ?? (isMobile ? "20px" : "45px"),
          transform: "translateY(-50%)",
        }}
      />
    </Button>
  );
};
